import React from 'react';
import './styles.scss';
import imagenLogin from '../../../resources/splash.jpg';
import { Label, Input, Button } from 'reactstrap';
import { Services } from './Services';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

const BackgroundHead = {
  height: '100%',
  backgroundImage: 'url(' + imagenLogin + ')',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: 'calc(100vw + 48px)',
  margin: -24,
  padding: 24,
};
/*=============================================
=            Login Component                  =
=============================================*/
function Recover(props) {
  const [redirectlogin, setRedirectlogin] = React.useState(
    {
      login: {
        newcontrasena: '',
        valid: false,
        confirmarcontrasena: '',
        check: false,
        email: ''
      }
    });
  let [Mostrar, setMostrar] = React.useState(false);
  let [exito, setexito] = React.useState(false);
  let [TokenValido, setTokenValido] = React.useState(true);

  const getAutentication = React.useCallback(() => {
    axios.get(`${Services.SetAutenticationrecover.path}admin/recovery?token=${props.match.params.token}`, {
    }).then(response => {
      redirectlogin.login.email = response.data.email;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
      setTokenValido(true)
      // console.log("redirectlogin___");

    }).catch(error => {
      console.log("error", error);
      setTokenValido(false)
    });
  }, [props.match, redirectlogin])

  React.useEffect(() => {
    // console.log("redirectlogin__2");

    getAutentication();
  }, [])

  function change(event) {
    document.getElementById('email_sin').setAttribute('hidden', 'hidden');
    document.getElementById('pass_sin').setAttribute('hidden', 'hidden');
    if (event.target.name === 'confirmarcontrasena') {
      let value = event.target.value;
      if (redirectlogin.login.newcontrasena === value) {
        document.getElementById('pass_diferentes').setAttribute('hidden', 'hidden');
        document.getElementById('se_cumple').removeAttribute('hidden');

        // document.getElementById('input_correo').className = 'input100';
      }
      else {
        document.getElementById('pass_diferentes').removeAttribute('hidden');
        document.getElementById('se_cumple').setAttribute('hidden', 'hidden');
      }
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    }
    else {
      let value = event.target.value;

      const emailRegex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&_-])([A-Za-z\d$@$!%*?&_-]|[^ ]){8,15}$/);
      if (emailRegex.test(value)) {
        // document.getElementById('input_email').className = 'input100';
        document.getElementById('123456').setAttribute('hidden', 'hidden');
      }
      else {
        // document.getElementById('input_email').className = 'invalidInput';
        document.getElementById('123456').removeAttribute('hidden');
      }
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    }
  }

  function handleLoginId() {
    if (!redirectlogin.login.newcontrasena) {
      document.getElementById('email_sin').removeAttribute('hidden');
    }
    else if (!redirectlogin.login.confirmarcontrasena) {
      document.getElementById('pass_sin').removeAttribute('hidden');
    }
    else {
      document.getElementById('email_sin').setAttribute('hidden', 'hidden');
      document.getElementById('pass_sin').setAttribute('hidden', 'hidden');
      let data = {
        email: redirectlogin.login.email,
        password: redirectlogin.login.newcontrasena
      };


      axios.put(`${Services.changePassword.path}admin/changePass`, data).then(response => {
        document.getElementById('pass_changue').removeAttribute('hidden');
        setexito(true)
      }).catch(error => {
        console.log("error", error);
      });
    }
  }
  return (
    <div className="limiter" style={BackgroundHead}>
      <div className="container-login100">
        {TokenValido ?
          <div className="wrap-login100 p-t-0 p-b-0" style={{ background: 'transparent' }}>
            <div>
              <div className="col-12" >
                {exito ? <label style={{ color: 'white', fontSize: '34px' }}>Password updated correctly</label>
                  :
                  <>
                    <label style={{ color: 'white', fontSize: '30px' }}>Recover password</label>
                    <div style={{ height: 15 }} />
                    <label style={{ color: 'white', fontSize: '16px' }}>The password must be composed of:</label>
                    <label style={{ color: 'white', fontSize: '16px' }}>* Minimum 8 digits and up to maximum 15 digits.</label>
                    <label style={{ color: 'white', fontSize: '16px' }}>* At least one uppercase and one lowercase letter.</label>
                    <label style={{ color: 'white', fontSize: '16px' }}>* A special character (*! $% &? _-).</label></>
                }
              </div>
            </div>
            <div style={{ height: 25 }} />
            {exito ? <></> : <div className="col-12" style={{ textAlign: 'center' }}>
              <div className="wrap-input100 validate-input m-b-12 " data-validate="Usuario es Requerido">
                {/* <input 
                className="input100" 
                id="input_email" 
                type={Mostrar ? "text" : "password"}
                 value={redirectlogin.login.newcontrasena}
                  name="newcontrasena" 
                  onChange={change}
                   placeholder="Nueva contraseña" /> */}

                <Input
                  type={Mostrar ? "text" : "password"}
                  id="input_email"
                  name="newcontrasena"
                  placeholder="New Password"
                  onChange={change}
                  value={redirectlogin.login.newcontrasena}
                // defaultValue="Error input"
                />
                <span className="focus-input100"></span>
              </div>
              <div className="wrap-input100 validate-input m-b-12" data-validate="Contraseña es Requerida">
                {/* <input
                 id="input_correo"
                className="input100" 
                type={Mostrar ? "text" : "password"} 
                value={redirectlogin.login.confirmarcontrasena} 
                name="confirmarcontrasena" 
                onChange={change} 
                placeholder="Confirmar contraseña" /> */}

                <Input
                  type={Mostrar ? "text" : "password"}
                  id="input_correo"
                  name="confirmarcontrasena"
                  placeholder="Confirm Password"
                  onChange={change}
                  value={redirectlogin.login.confirmarcontrasena}
                // defaultValue="Error input"
                />
                <span className="focus-input100"></span>
              </div>
              <div style={{ padding: '3px', marginTop: '-14px', color: 'white', fontSize: '15px' }} className="_alert" id="email_sin" hidden>Password is required</div>
              <div style={{ padding: '3px', marginTop: '-14px', color: 'white', fontSize: '15px' }} className="_alert" id="pass_sin" hidden>Confirm Password</div>
              <div style={{ padding: '3px', marginTop: '-14px', color: 'white', fontSize: '15px' }} className="_alert" id="pass_diferentes" hidden>Passwords must be the same</div>
              <div style={{ padding: '3px', marginTop: '-14px', color: 'white', fontSize: '15px' }} className="_alert" id="pass_changue" hidden>Your password has been successfully changed</div>
              <div style={{ padding: '3px', marginTop: '-14px', color: 'white', fontSize: '15px' }} className="_alert" id="123456" hidden>Invalid password</div>
            </div>
            }
            {exito ? <></> : <div className=" col-6">
              <div style={{ fontSize: '11px !important' }} className="col-12">
                <Label style={{ color: 'white' }}  >
                  <Input type="checkbox" onChange={() => {
                    setMostrar(!Mostrar);
                  }} checked={Mostrar} />View
                </Label>
              </div>
            </div>}
            <div style={{ height: 5 }} />
            {exito ? <></> : <div className="container-login100-form-btn">
              <div className="col-10 mr-auto ml-auto">
                <Button
                  id='se_cumple'
                  hidden
                  color="success"
                  block
                  onClick={handleLoginId}>
                  Change
                </Button>
              </div>
            </div>}
          </div>
          :
          <div>
            <div style={{ height: '10em' }} className="col-12" ></div>
            <div className="col-12" >
              <label style={{ color: 'white', fontSize: '30px' }}>Error: "El token ya se ha utilizado o ha caducado" </label>
            </div>
          </div>
        }
      </div>
    </div>
  );
}
export default withRouter(Recover);
